import { useTranslation } from '@thoughtspot/i18n';
import { Alert, BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Link } from '@thoughtspot/radiant-react/widgets/link';
import { Modal, ModalSize, } from '@thoughtspot/radiant-react/widgets/modal';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useEffect, useRef, useState } from 'react';
import { installCertificateMutation, onDownloadCertificateUtil, useGetCertificateStatusLazyQuery, } from "../../../services/keystore/keystore-service";
import { create } from '../../../utils/logger';
import { WithQueryHandler } from '../common';
import styles from './saml-license-banner.module.scss';
var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["BANNER_MESSAGE"] = "saml.thoughtspotCluster.certificate";
    TranslationsKeys["DOWNLOAD"] = "saml.thoughtspotCluster.download.text";
    TranslationsKeys["INSTALL"] = "saml.thoughtspotCluster.install.text";
    TranslationsKeys["READ_MORE"] = "saml.thoughtspotCluster.readMoreLink.text";
    TranslationsKeys["CANCEL"] = "Cancel";
    TranslationsKeys["DIALOGUE_FIRST_CONTENT"] = "saml.thoughtspotCluster.alertDialog.firstDescription";
    TranslationsKeys["DIALOGUE_SECOND_CONTENT"] = "saml.thoughtspotCluster.alertDialog.secondDescription";
    TranslationsKeys["MODAL_INSTALL_BUTTON_TEXT"] = "saml.thoughtspotCluster.modalInstallButton.text";
    TranslationsKeys["INSTALL_FAIL_MSG"] = "saml.thoughtspotCluster.installFailure.text";
    TranslationsKeys["INSTALL_MODAL_HEADER"] = "saml.thoughtspotCluster.modalInstallHeader.text";
})(TranslationsKeys || (TranslationsKeys = {}));
const UPDATED_CERTIFICATE_PATH = '/callosum/v1/keystore/certificate/updated';
const MORE_LINK = 'https://community.thoughtspot.com/s/article/Field-Advisory-Your-ThoughtSpot-X-509-SAML-certificate-will-expire-on-December-30-2022';
const logger = create('saml.license.banner.container');
export const SAMLLicenseBannerContainer = ({ bannerVisible, }) => {
    const { t } = useTranslation();
    const installFailure = useRef({ isFailed: false });
    const [showBanner, setShowBanner] = useState(false);
    const [showInstallModal, setShowInstallModal] = useState(false);
    const [isReload, setIsReload] = useState(false);
    const { error: getCertError, data: getCertData, loading: getCertLoading, getCertificateStatusLazy, } = useGetCertificateStatusLazyQuery();
    const { data: installCertData, loading: installCertLoading, installCertificate, } = installCertificateMutation();
    const primaryButtonAction = () => {
        installCertificate().catch(error => {
            installFailure.current.isFailed = true;
            setIsReload(!isReload);
        });
        setShowInstallModal(false);
    };
    const secondaryButtonAction = async () => {
        await onDownloadCertificateUtil(UPDATED_CERTIFICATE_PATH);
    };
    const installButton = {
        text: t(TranslationsKeys.MODAL_INSTALL_BUTTON_TEXT),
        onConfirm: primaryButtonAction,
    };
    const closeAlertDialogue = () => {
        setShowInstallModal(false);
    };
    const openAlertDialogue = () => {
        setShowInstallModal(true);
    };
    const closeButton = {
        text: t(TranslationsKeys.CANCEL),
        onConfirm: closeAlertDialogue,
    };
    useEffect(() => {
        try {
            getCertificateStatusLazy();
        }
        catch (err) {
            logger.error(err);
        }
    }, []);
    useEffect(() => {
        if (getCertData) {
            setShowBanner(getCertData || false);
        }
    }, [getCertData, getCertLoading]);
    useEffect(() => {
        const status = installCertData?.Status === 200 || false;
        if (status) {
            installFailure.current.isFailed = false;
            setShowBanner(false);
        }
    }, [installCertData, installCertLoading]);
    const bannerMsg = () => {
        const { isFailed } = installFailure.current;
        return (React.createElement("div", null,
            isFailed
                ? t(TranslationsKeys.INSTALL_FAIL_MSG)
                : t(TranslationsKeys.BANNER_MESSAGE),
            ' ',
            !isFailed ? (React.createElement(Link, { className: styles.readMoreLink, href: MORE_LINK, target: "_blank", rel: "noreferrer" }, t(TranslationsKeys.READ_MORE))) : null,
            React.createElement(Button, { text: t(TranslationsKeys.DOWNLOAD), type: "primary", size: "s", backgroundType: "colored", className: styles.secondaryButton, onClick: secondaryButtonAction }),
            React.createElement(Button, { text: t(TranslationsKeys.INSTALL), type: "primary", size: "s", backgroundType: "colored", className: styles.primaryButton, onClick: openAlertDialogue })));
    };
    return showBanner ? (React.createElement(React.Fragment, null,
        React.createElement(Alert.Banner, { isVisible: bannerVisible, message: bannerMsg(), type: BannerAlertType.ERROR, showCloseButton: false, className: styles.errorBanner }),
        showInstallModal && (React.createElement(Modal, { title: t(TranslationsKeys.INSTALL_MODAL_HEADER), size: ModalSize.SMALL, isOpen: showInstallModal, autoScrollContent: false, confirmButton: installButton, dismissButton: closeButton, onDismiss: closeAlertDialogue },
            React.createElement(Vertical, null,
                React.createElement(Typography, { variant: "body-large", overrideTag: "div", noMargin: true }, t(TranslationsKeys.DIALOGUE_FIRST_CONTENT)),
                React.createElement(Typography, { color: Colors.accent, variant: "body-large", overrideTag: "div", className: styles.installModalSecondContent, onClick: secondaryButtonAction }, t(TranslationsKeys.DIALOGUE_SECOND_CONTENT))))))) : null;
};
const MemoizedSAMLLicenseBannerContainer = React.memo(SAMLLicenseBannerContainer);
export const SAMLLicenseBanner = (props) => (React.createElement(WithQueryHandler, null,
    React.createElement(MemoizedSAMLLicenseBannerContainer, { ...props })));
//# sourceMappingURL=saml-license-banner.container.js.map